import React from "react";
import ErrorBoundary from "../../hoc/errorBoundary/error.js";
import classes from "./rivers.module.scss";
import ChooseRiver from "../../components/home/river_info/components/chooseRiver/chooseRiver";
import ArticleMax from "../../components/home/river_info/components/articleMax/articleMax";

function Rivers(props) {
  return (
    <ErrorBoundary>
      <div className={classes.wrapper}>
        <div>
          <ChooseRiver classModifier={"container"} />
        </div>
        <ArticleMax />
      </div>
    </ErrorBoundary>
  );
}

export default Rivers;
